import Container from '@mui/material/Container'

import Heading from '~/client/components/Heading'

export default function AboutPage() {
  return <Container>
    <Heading my={4} variant="major">About</Heading>
    <p>DataPal is a service that enables you to gain control of your personal data, and earn value from it.</p>
  </Container>
}
